import { getPageAllowedRoles } from "../../config/roles";
import { fullWidth } from "../../blocks/layout/columnSpans";
import { PageDefinition } from "../pageDefinition.types";
import { SettingsLinks } from "./SettingsLinks";

/** The way into each settings page, showing only those the user's roles open. */
export const settingsPageDefinition: PageDefinition = {
  path: "/settings",
  title: "Settings",
  allowedRoles: getPageAllowedRoles("settings"),
  rows: [
    {
      id: "row-links",
      panels: [
        {
          id: "panel-links",
          // The page bar already says Settings.
          title: "",
          span: fullWidth,
          component: SettingsLinks,
          plain: true,
        },
      ],
    },
  ],
};
